import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const SignupWrapper = styled.div`
  padding: 20px 0px;
    background-color: white;
  @media(min-width: ${TABLET_WIDTH}px) {
    background-color: #2680EB;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${props => props.app.color1} inset !important;
    -webkit-text-fill-color: white;
  }

  .link_conditions {
    text-decoration: underline;
  }
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const Camera = styled.i`
  font-size: 24px;
`;

export const Delete = styled.i`
  font-size: 14px;
  padding: 3px 5px;
`;

export const AvatarOverflow = styled.div`
  overflow: hidden;
`;

export const ButtonLogin = styled.button`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.3rem;
  width: 15rem;
  padding: 1.2rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: #2680EB;
  margin-bottom: 2rem;
`;

export const PrevInfo = styled.div`
  font-size: 1.4rem;
  margin-bottom: 3rem;
  .text {
    margin: 1rem;
  }
  .title {
    font-size: 1.8rem;
    font-weight: bold;
    margin: 1rem;
    margin-bottom: 3rem;
  }
`;

export const ProfilePhotoWrapper = styled.div`
  height: 100%;
  background: white;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .content {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media(min-width: ${TABLET_WIDTH}px) {
      max-width: 50%;
      min-height: 50%;
      margin: 0 auto;
      background: white;
      padding: 3rem;
      border-radius: 2rem;
      box-shadow: 0px 3px 6px 1px lightgray;
    }
  }

  .button {
    height: 15rem;
    width: 15rem;
    color: white;
    background: #2680EB;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7rem;
  }
  #user {
    font-size: 9rem;
  }
  p {
    font-size: 1.3rem;
    margin: 3rem 0rem;
  }
  .fadein .avatar_preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 15rem;
    width: 15rem;
    border-radius: 7rem;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

export const LinkedInWrapper = styled.div`
  height: 100%;
  background: white;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .content {
    @media(min-width: ${TABLET_WIDTH}px) {
      max-width: 50%;
      min-height: 50%;
      margin: 0 auto;
      background: white;
      padding: 3rem;
      border-radius: 2rem;
      box-shadow: 0px 3px 6px 1px lightgray;
    }
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .button {
    height: 15rem;
    width: 15rem;
    color: white;
    background: #2680EB;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7rem;
  }
  #user {
    font-size: 9rem;
  }
  p {
    font-size: 1.3rem;
    margin: 3rem 0rem;
  }
  input {
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    width: 30rem;
    height: 5rem;
    border-radius: 1rem;
    border: none;
    font-size: 1.1rem;
    padding: 2rem;
    outline: none;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Signup/components/styles.js